export const IconHelmet = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M14.969 10.649v4.54l6.183 3.093a.586.586 0 0 0 .848-.524v-6.23zM13.284 10.438a.585.585 0 0 0-.659.581v2.636c0 .224.124.424.324.524l.848.424v-4.101z" />
      <path d="M11.453 13.656v-2.637c0-1.067.943-1.877 1.976-1.744l8.486 1.061a10.04 10.04 0 0 0-4.266-6.597c-2.486-1.668-5.626-2.166-8.547-1.364C5.208 3.444 2 7.801 2 11.991v2.806a1.77 1.77 0 0 0 1.049 1.61l12.94 5.334a3.375 3.375 0 0 0 4.439-1.891c.062-.156.127-.35.192-.523l-8.195-4.099a1.76 1.76 0 0 1-.972-1.572m-4.726 1.31a2.346 2.346 0 0 1-2.344-2.344 2.346 2.346 0 0 1 2.344-2.344 2.346 2.346 0 0 1 2.343 2.344 2.346 2.346 0 0 1-2.343 2.344" />
      <path d="M6.727 11.45c-.646 0-1.172.526-1.172 1.172s.526 1.172 1.172 1.172 1.171-.526 1.171-1.172-.525-1.172-1.171-1.172" />
    </svg>
  );
};
